const mEditionAcademyAutoresponders = {
  mEditionAcademyAutoresponders: {
    accessDenied: {
      firstText: 'Tu plan no permite la integración con Autoresponders, para aumentar las características de tu plan actual haz click en el siguiente enlace',
      linkText: 'actualizar plan.'
    },

    action: 'Seleccionar',

    table: {
      thAccount: 'Descripción',
      thAutoresponder: 'Autoresponder',
      thDelete: 'Eliminar'
    },

    title: {
      first: 'Selecciona el tipo de autoresponder que deseas asociar a Vidroop',
      second: 'Cuentas de autoresponders asociadas a Vidroop'
    },

    tooltip: {
      delete: 'Eliminar Cuenta'
    }
  }
}

export default mEditionAcademyAutoresponders
